<template>
  <div>
    <b-row>
      <b-col
        v-for="(persona, index) in this.store.state.personaData"
        :key="index"
        lg="6"
        class="pt-3 pb-2"
        style="overflow:visible"
      >
        <PersonaCard :persona="persona" :index="index" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import store from '../../store';

import PersonaCard from './PersonaCard.vue';
export default {
  name: 'PersonaContainer',
  components: {
    PersonaCard,
  },
  data() {
    return {
      store,
    };
  },
};
</script>
<style scoped>
@media (min-width: 992px) and (max-width: 1333px) {
  #app .col-lg-6 {
    flex: none;
    max-width: 80%;
  }
}
</style>
